/* eslint-disable react-hooks/exhaustive-deps */
import { SearchOutlined } from '@ant-design/icons';

import {
    Form,
    Input,
    Select,
    DatePicker,
    Radio,
    Space,
    Button,
    AutoComplete,
    Cascader,
    Checkbox,
} from 'antd';
import classNames from 'classnames';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Option } = Select;
const { RangePicker } = DatePicker;

const SearchBar = ({
    item,
    onFinish,
    onClear,
    initialValues,
    loading,
    btnClearRef,
    formRef,
    className,
}) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [options, setOptions] = useState([]);
    const [check, setCheck] = useState(true);

    const onSearch = async (searchText, index, api) => {
        let temp = options || [];
        if (searchText.length >= 3 && temp[index] === undefined) {
            let departmentId = form.getFieldValue('department');
            await api(departmentId).then((res) => {
                temp[index] =
                    res?.data?.resultData.map((e) => {
                        return { value: e.name };
                    }) || [];
            });
        }
        setOptions([...temp]);
    };

    const disabledDate = (current, rule) => {
        return current >= rule;
    };

    const genForm = (e, i) => {
        if (e.name === 'sortBy' && !e.custom) {
            let optionSortby = [
                {
                    value: 'modify_date',
                    label: t('Update Date'),
                    children: [
                        {
                            value: 'ASC',
                            label: t('Ascending'),
                        },
                        {
                            value: 'DESC',
                            label: t('Descending'),
                        },
                    ],
                },
                {
                    value: 'business_name',
                    label: t('Business Process'),
                    children: [
                        {
                            value: 'ASC',
                            label: t('Ascending'),
                        },
                        {
                            value: 'DESC',
                            label: t('Descending'),
                        },
                    ],
                },
            ];
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                    initialValue={['modify_date', 'DESC']}
                >
                    <Cascader
                        allowClear={false}
                        size="large"
                        options={e.option ? e.option : optionSortby}
                        placeholder={e.placeholder}
                        showArrow
                    />
                </Form.Item>
            );
        } else if (e.type === 'Input') {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                >
                    <Input size="large" placeholder={e.placeholder} />
                </Form.Item>
            );
        } else if (e.type === 'Select') {
            return (
                <Form.Item
                    className="mt-4 max-w-[290px]"
                    name={e.name}
                    label={e.label}
                    key={i}
                >
                    <Select
                        {...e}
                        onChange={(ele) => {
                            if (e.onChange) {
                                e.onChange(ele);
                            }
                            if (e.onChangeResetField) {
                                form.resetFields(e.onChangeResetField);
                            }
                            if (e.onChangeSetDefault) {
                                setCheck(e.onChangeSetDefault);
                            }
                        }}
                        size="large"
                        placeholder={e.placeholder}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.children ?? '')
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {e.defaultValue && (
                            <Option key={e.defaultValue} value={''}>
                                {e.defaultValue}
                            </Option>
                        )}
                        {e.option?.map((el) => (
                            <Option key={el.id} value={el.id}>
                                {el.value}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );
        } else if (e.type === 'RangePicker') {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                >
                    <RangePicker
                        disabledDate={(el) => disabledDate(el, e.disabledDate)}
                        size="large"
                        placeholder={e.placeholder}
                    />
                </Form.Item>
            );
        } else if (e.type === 'Checkbox') {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                    initialValue={e.initialValue || e.option[0]}
                >
                    <Checkbox.Group size="large">
                        <Space direction="vertical">
                            {e.option?.map((el) => (
                                <Checkbox key={el} value={el}>
                                    {el}
                                </Checkbox>
                            ))}
                        </Space>
                    </Checkbox.Group>
                </Form.Item>
            );
        } else if (e.type === 'CheckboxByKey' && e.initialValue) {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                    initialValue={e.initialValue || e.option[0]}
                >
                    <Checkbox.Group size="large">
                        <Space direction="vertical">
                            {e.option?.map((el) => (
                                <Checkbox key={el.id} value={el.id}>
                                    {el.value}
                                </Checkbox>
                            ))}
                        </Space>
                    </Checkbox.Group>
                </Form.Item>
            );
        } else if (e.type === 'Radio') {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                    initialValue={e.option[0]}
                >
                    <Radio.Group size="large">
                        <Space direction="vertical">
                            {e.option?.map((el) => (
                                <Radio key={el} value={el}>
                                    {el}
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>
                </Form.Item>
            );
        } else if (e.type === 'AutoComplete') {
            return (
                <Form.Item
                    className="mt-4"
                    name={e.name}
                    label={e.label}
                    key={i}
                >
                    <AutoComplete
                        options={[...(options[i] || [])]}
                        onSearch={(el) => onSearch(el, i, e.api)}
                        filterOption={(inputValue, option) =>
                            option.value
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                        }
                    >
                        <Input
                            size="large"
                            prefix={
                                <SearchOutlined style={{ color: '#65707A' }} />
                            }
                            placeholder={e.placeholder}
                        />
                    </AutoComplete>
                </Form.Item>
            );
        }
    };

    useEffect(() => {
        if (
            (check === true || check.length > 0) &&
            initialValues !== undefined
        ) {
            if (check === true) {
                form.setFieldsValue(initialValues);
            } else {
                let temp = initialValues;
                check.forEach((e) => {
                    delete temp[e];
                });
                form.setFieldsValue(temp);
            }
            setCheck([]);
        }
    }, [initialValues]);

    return (
        <div className={classNames('searchbar_', className)}>
            <div>
                <span className="title">{t('Search Filter')}</span>
            </div>
            <div>
                <Form
                    layout="vertical"
                    form={formRef ?? form}
                    initialValues={initialValues}
                    onFinish={onFinish}
                >
                    {item.map((e, i) => genForm(e, i))}
                    <div className="mt-8 flex space-x-4">
                        <Form.Item className="flex-1">
                            <Button
                                size="large"
                                htmlType="reset"
                                ref={btnClearRef}
                                onClick={(e) => {
                                    onClear(e);
                                    setCheck(true);
                                }}
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-full"
                            >
                                {t('common.Clear')}
                            </Button>
                        </Form.Item>
                        <Form.Item className="flex-1">
                            <Button
                                loading={loading}
                                size="large"
                                htmlType="submit"
                                type="primary"
                                className="w-full"
                            >
                                {t('Apply')}
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default SearchBar;
